<template>
  <modal
    :name="name ? name : 'add-hgs-detail-modal'"
    :height="isMobile ? '100%' : 'auto'"
    :width="isMobile ? '100%' : '600px'"
    :scrollable="true"
  >
    <!-- Modern Header -->
    <div class="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 p-6">
      <div class="flex items-center justify-between">
        <div class="flex items-center space-x-3">
          <div class="w-10 h-10 bg-red-800 rounded-lg flex items-center justify-center">
            <i class="fas fa-road text-white text-sm"></i>
          </div>
          <div>
            <h3 class="text-lg font-bold text-gray-900 dark:text-white">Otoyol Maliyet Detayı</h3>
            <p class="text-sm text-gray-500 dark:text-gray-400">Ücretli yollar ve köprü geçiş ücretleri</p>
          </div>
        </div>
        <button
          type="button"
          @click="$modal.hide(name ? name : 'add-hgs-detail-modal')"
          class="w-8 h-8 rounded-lg bg-gray-100 hover:bg-gray-200 dark:bg-gray-700 dark:hover:bg-gray-600 flex items-center justify-center transition-colors"
        >
          <i class="fas fa-times text-gray-600 dark:text-gray-400 text-sm"></i>
        </button>
      </div>
    </div>

    <!-- Content Area -->
    <div class="bg-gray-50 dark:bg-gray-900 max-h-96 overflow-y-auto">
      <!-- Toll Roads Section -->
      <div v-if="List && List.length > 0" class="p-6">
        <div class="mb-4">
          <h4 class="text-sm font-semibold text-gray-900 dark:text-white mb-1">Ücretli Otoyollar</h4>
          <p class="text-xs text-gray-500 dark:text-gray-400">HGS ve OGS geçiş ücretleri</p>
        </div>
        
        <div class="space-y-2">
          <div
            v-for="(item, index) in List"
            :key="index"
            class="bg-white dark:bg-gray-800 rounded-lg p-4 border border-gray-200 dark:border-gray-700"
          >
            <div class="flex items-center justify-between">
              <div class="flex items-center space-x-3">
                <div class="w-8 h-8 bg-green-100 dark:bg-green-900/30 rounded-lg flex items-center justify-center">
                  <i class="fas fa-highway text-green-600 dark:text-green-400 text-xs"></i>
                </div>
                <div>
                  <p class="text-sm font-medium text-gray-900 dark:text-white">{{ item.name }}</p>
                  <p class="text-xs text-gray-500 dark:text-gray-400">Otoyol geçiş ücreti</p>
                </div>
              </div>
              <div class="text-right">
                <div class="text-lg font-bold text-green-600 dark:text-green-400">{{ Money(item.price) }}₺</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Bridges Section -->
      <div v-if="bridges && bridges.length > 0" class="px-6 pb-6">
        <div class="mb-4">
          <h4 class="text-sm font-semibold text-gray-900 dark:text-white mb-1">Köprü Geçiş Ücretleri</h4>
          <p class="text-xs text-gray-500 dark:text-gray-400">Boğaz ve diğer köprü ücretleri</p>
        </div>
        
        <div class="space-y-2">
          <div
            v-for="(item, index) in bridges"
            :key="'bridge-' + index"
            class="bg-white dark:bg-gray-800 rounded-lg p-4 border border-gray-200 dark:border-gray-700"
          >
            <div class="flex items-center justify-between">
              <div class="flex items-center space-x-3">
                <div class="w-8 h-8 bg-blue-100 dark:bg-blue-900/30 rounded-lg flex items-center justify-center">
                  <i class="fas fa-bridge text-blue-600 dark:text-blue-400 text-xs"></i>
                </div>
                <div>
                  <p class="text-sm font-medium text-gray-900 dark:text-white">{{ item.name }}</p>
                  <p class="text-xs text-gray-500 dark:text-gray-400">Köprü geçiş ücreti</p>
                </div>
              </div>
              <div class="text-right">
                <div class="text-lg font-bold text-blue-600 dark:text-blue-400">{{ Money(item.price) }}₺</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Empty State -->
      <div v-if="(!List || List.length === 0) && (!bridges || bridges.length === 0)" class="p-12 text-center">
        <div class="w-16 h-16 bg-gray-100 dark:bg-gray-800 rounded-full flex items-center justify-center mx-auto mb-4">
          <i class="fas fa-road text-gray-400 text-xl"></i>
        </div>
        <h3 class="text-lg font-medium text-gray-900 dark:text-white mb-2">Ücretli Yol Yok</h3>
        <p class="text-gray-500 dark:text-gray-400">Bu rotada herhangi bir ücretli yol veya köprü geçişi bulunmuyor.</p>
      </div>
    </div>

    <!-- Footer with Total -->
    <div v-if="getTotal > 0" class="bg-gradient-to-r from-red-50 to-red-100 dark:from-red-900/20 dark:to-red-800/20 border-t border-red-200 dark:border-red-700 p-6">
      <div class="flex items-center justify-between">
        <div class="flex items-center space-x-3">
          <div class="w-10 h-10 bg-red-800 rounded-lg flex items-center justify-center">
            <i class="fas fa-calculator text-white text-sm"></i>
          </div>
          <div>
            <p class="text-sm font-semibold text-red-800 dark:text-red-200">Toplam Otoyol Maliyeti</p>
            <p class="text-xs text-red-600 dark:text-red-400">Tüm ücretli geçişlerin toplamı</p>
          </div>
        </div>
        <div class="text-right">
          <div class="text-2xl font-bold text-red-800 dark:text-red-200">{{ Money(getTotal) }}₺</div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  name: "hgs-detail-modal",
  props: ["List", "bridges", "name"],
  computed: {
    getTotal() {
      let total = 0;
      this.List.forEach((el) => {
        total += parseFloat(el.price);
      });

      if (this.bridges) {
        this.bridges.forEach((el) => {
          total += parseFloat(el.price);
        });
      }

      return total;
    },
  },
};
</script>

<style></style>
